import TextAreaField from "../../../../../Forms/Input/TextAreaField";

const EditableFieldsSection = ({ form, formErrors, updateField }) => (
  <div className="mb-6">
    <TextAreaField
      label="Razón"
      name="reason"
      value={form.reason || ""}
      iconKey="edit"
      error={formErrors?.reason}
      onChange={(e) => updateField("reason", e.target.value)}
      rows={3}
    />
  </div>
);

export default EditableFieldsSection;
